// 方案五：靛蓝色系 - 专业、现代、科技感
// 适合：现代职业测评平台，传达科技感和专业性
export const professionalIndigoTheme = {
  colors: {
    'psychology-primary': '#4F46E5',      // 靛蓝色 - 专业、现代、科技感
    'psychology-secondary': '#4338CA',    // 更深靛蓝 - 辅助色，稳重
    'psychology-accent': '#6366F1',       // 亮靛蓝 - 强调色，现代感
    'psychology-calm': '#EEF2FF',         // 极浅靛蓝 - 背景色，清新
    'psychology-warm': '#E0E7FF',         // 浅靛蓝 - 温暖背景
    'psychology-success': '#10B981',      // 绿色 - 成功、积极
    'psychology-info': '#6366F1',         // 靛蓝色 - 信息状态
    'psychology-warning': '#F59E0B',      // 橙色 - 警告状态
  },
  name: 'professional-indigo',
  description: '靛蓝色系主题 - 专业、现代、科技感，适合现代职业测评平台'
}

